export const loadedStyle: React.CSSProperties = {
  height: '100%',
  backgroundColor: '#fff',
  alignItems: 'flex-start'
};

export const loadingStyle: React.CSSProperties = {
  backgroundColor: '#d9d9d9',
  alignItems: 'center'
};
